module.exports = __webpack_public_path__ + "static/media/greenhouse2Step7-1.d0386698.jpg";